import ENUM from "../utils/constUtils";

const filters = {
  codeToName: value => {
    const res = ENUM.LOGISTICS_COMPANY.find(item => item.value == value);
    return res ? res.label : value;
  }
};

export default function(vue) {
  Object.keys(filters).forEach(key => {
    vue.filter(key, filters[key]);
  });
}
